import React from "react"

function PanelContent({ children }) {
  return <div className="x_content">{children}</div>
}

export default PanelContent
